// | ------------------------------------------------------------------------
// | GSAP Scroll Animations - Virtual Office Call-to-action
// | ------------------------------------------------------------------------

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// | ------------------------------------------------------------------------

//Register ScrollTrigger
gsap.registerPlugin(ScrollTrigger);

// | ------------------------------------------------------------------------

function virtualOfficeCta(showMarkers, officeSection) {
  const officeCtaBg = gsap.timeline({
    paused: "true",
    scrollTrigger: {
      trigger: officeSection,
      start: "-=600px",
      //start: "top top",
      end: "bottom",
      scrub: true,
      markers: showMarkers,
      id: "office-cta",
    },
  });

  gsap.set(".office-abstract-1", {
    position: "absolute",
    scale: 0.4,
    x: "-50%",
    y: "-35%",
    filter: "blur(10px)",
  });

  officeCtaBg.to(
    ".office-abstract-1",
    {
      scale: 0.5,
      x: "-40%",
      y: "-37%",
      filter: "blur(2px)",
      duration: 300,
      ease: "power2.out",
    },
    0
  );

  gsap.set(".office-abstract-2", {
    position: "absolute",
    scale: 1,
    x: "150%",
    y: "0%",
    filter: "blur(0px)",
  });

  officeCtaBg.to(
    ".office-abstract-2",
    {
      scale: 0.85,
      x: "120%",
      y: "-10%",
      filter: "blur(10px)",
      duration: 300,
      ease: "power4.out",
    },
    0
  );

  gsap.set(".office-abstract-3", {
    position: "absolute",
    scale: 0.5,
    right: "-10%",
    y: "-70%",
    filter: "blur(20px)",
  });

  officeCtaBg.to(
    ".office-abstract-3",
    {
      scale: 0.7,
      right: "0%",
      y: "-50%",
      filter: "blur(0px)",
      duration: 300,
    },
    0
  );
}

export { virtualOfficeCta };
